import { get } from "lodash";
import { ResidentialStatusEnum } from "../enum/residential-status.enum";
import { SexEnum } from "../enum/sex.enum";
import { RaceType } from "../enum/race.enum";
import { NationalityType } from "../enum/nationality.enum";
import { RoleNameType } from "../enum/role-name.enum";

export class MyInfo {
  uinfin              : string;
  name                : string;
  sex                 : SexEnum;
  race                : RaceType | null;
  nationality         : NationalityType | null;
  residential_status  : ResidentialStatusEnum | string;
  dob                 : string;
  mobile_no           : string;
  marital_status      : string;
  email               : string;
  
  constructor(initial?: any) {
    this.uinfin               = get(initial, 'uinfin',             '');
    this.name                 = get(initial, 'name',               '');
    this.residential_status   = get(initial, 'residential_status', '');
    this.dob                  = get(initial, 'dob',                '');
    this.mobile_no            = get(initial, 'mobile_no',          '');
    this.marital_status       = get(initial, 'marital_status',     '');
    this.email                = get(initial, 'email',              '');
    this.sex                  = get(initial, 'sex',                null);
    this.race                 = get(initial, 'race',               null);
    this.nationality          = get(initial, 'nationality',        null);
  }
}            
type LiveStatusStatus = "A" | "D";                                                     
export class MyInfoWithDOD extends MyInfo {
  dod:string;
  live_status: LiveStatusStatus;  
  role_name: RoleNameType;  
  constructor(initial?: any) {
    super(initial);
    this.dod                 = get(initial, 'dod',                '');
    this.live_status         = get(initial, 'live_status',        'A') || "A"; //PREVENT FALSY VALUE
    this.role_name           = get(initial, 'role_name',            '');
  }
}                                                                